import HubspotSourceIcon from "../../assets/components/sources/HubspotSourceIcon";

const HubspotLogomark = ({ height }: { height: number }) => {
  return <HubspotSourceIcon height={height} />;
};

export default HubspotLogomark;
